module.exports = __webpack_public_path__ + "static/media/smallthumbsdown.001c8371.svg";